import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../utils/sizes';

export * from './customer/default/solo.constants';

export const Z_INDEX_NORMAL = 0;

export const Z_INDEX_WITH_PROGRAM_INFO = 1000;

export const templates = {
  Solo: 'Solo',
};

export const sizes = {
  [templates.Solo]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: SCREEN_WIDTH[HD],
        h: Math.round(SCREEN_HEIGHT[HD] * 0.85),
      },
      [FULL_HD]: {
        w: SCREEN_WIDTH[FULL_HD],
        h: Math.round(SCREEN_HEIGHT[FULL_HD] * 0.85),
      },
    },
  },
};

export const imageOptions = {
  [templates.Solo]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: sizes[templates.Solo][RENDERING_CONTEXT.GENERAL][HD].w,
          height: sizes[templates.Solo][RENDERING_CONTEXT.GENERAL][HD].h,
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: sizes[templates.Solo][RENDERING_CONTEXT.GENERAL][FULL_HD].w,
          height: sizes[templates.Solo][RENDERING_CONTEXT.GENERAL][FULL_HD].h,
        },
      },
    },
  },
};
